export const chipsThatFit = (
  measuredWidths: readonly number[],
  count: number,
  available: number,
  gap: number,
  badgeWidth: number,
): number => {
  const all = measuredWidths.reduce((sum, width) => sum + width, 0) + gap * Math.max(measuredWidths.length - 1, 0);
  if (count === measuredWidths.length && all <= available) return count;

  let used = 0;
  let fits = 0;
  for (const width of measuredWidths) {
    if (used + width + gap + badgeWidth > available) break;
    used += width + gap;
    fits += 1;
  }
  // The first chip always shows, cut short if need be, so a pick is never just a number.
  return Math.max(fits, Math.min(count, 1));
};
